import { Client } from '@/api/cuSystemAnalyzerApi/client'
import { downloadControlUnitLogFile } from '@/api/cuSystemAnalyzerApi/sdk.gen'
import { DIAGNOSTICS_CU_LOG_DOWNLOAD_SIZE_MB } from '@/constants'
import { getAttachmentFileName } from '@/utils/download'
import { Stack, Tabs } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import LogDownloadCard from './LogDownloadCard'

/**
 * Used when the Content-Disposition header is missing or not exposed to the browser
 */
const FALLBACK_FILE_NAME = 'control-unit.log'

const CuLogDownloadsPanel = ({ client }: { client: Client }) => {
  const { t } = useTranslation(['diagnostics', 'common'])

  return (
    <Tabs.Panel value="cu-log-downloads">
      <Stack gap="md" mt="lg">
        <LogDownloadCard
          label={t('controlUnitLog')}
          fileName={FALLBACK_FILE_NAME}
          sizeMb={DIAGNOSTICS_CU_LOG_DOWNLOAD_SIZE_MB}
          fetchLog={async () => {
            const { data, response } = await downloadControlUnitLogFile({
              client,
              parseAs: 'blob',
              throwOnError: true,
            })
            const blob = data as Blob
            // The analyzer answers with an empty body when the control unit has no log file
            if (blob.size === 0) return null
            const fileName = getAttachmentFileName(response.headers.get('Content-Disposition')) ?? FALLBACK_FILE_NAME
            return { blob, fileName }
          }}
        />
      </Stack>
    </Tabs.Panel>
  )
}

export default CuLogDownloadsPanel
